import { action, makeObservable, observable } from "mobx";
import { API } from "aws-amplify";
// import { getUsers } from "../../../graphql/queries"; // Commented out - GraphQL removed

class SelectedUserStore {
  userData = {};
  isLoading = false;
  isError = false;

  constructor() {
    makeObservable(this, {
      userData: observable,
      isLoading: observable,
      isError: observable,
      fetchUserData: action,
      setUserData: action,
      clearUserData: action,
    });
  }

  
  fetchUserData = async (userId, customerId) => {
    this.isLoading = true;
    this.isError = false;
    try {
      // GraphQL removed - commented out
      // const response = await API.graphql({
      //   query: getUsers,
      //   variables: { input: { customer: customerId, id: userId } },
      //   authMode: 'AMAZON_COGNITO_USER_POOLS'
      // });

      // const userData = JSON.parse(response.data?.getUsers?.body);
      // this.userData = userData || {};
      // TODO: Replace with REST API call
      this.userData = {};
      this.isLoading = false;
    } catch (error) {
      this.isError = true;
      this.isLoading = false;
    }
  }

  
  setUserData = (data) => {
    this.userData = data;
  }

  
  clearUserData = () => {
    this.userData = {};
  }
}

export default SelectedUserStore;
